import {Link, useLocation} from 'react-router-dom';
import {useDispatch} from "react-redux";
import CustomIcon, {CustomIconRef} from "./CustomIcon";
import DropdownMenu, {DropdownItem, DropdownItemGroup} from "@atlaskit/dropdown-menu";
import {tryUserLogout} from "../redux/slices/loginSlice";

export default function AdminNavbar({showSidebar, setShowSidebar, isMobileViewSelected = true}) {
  const location = useLocation().pathname;


  const dispatch = useDispatch();

  const logout = () => {
    dispatch(tryUserLogout());
  };


  return (
    <>
      <nav className={`bg-rand-100 py-6 px-3${isMobileViewSelected ? ' xl:ml-64' : ''}`}>
        <div
          className={`container max-w-full mx-auto flex items-center justify-between${isMobileViewSelected ? ' xl:pr-8 xl:pl-10' : ''}`}>
          <div className={isMobileViewSelected ? 'xl:hidden' : ''}>
            <CustomIcon icon="menu" className="text-white cursor-pointer p-3" size="2xl"
                        onClick={() => setShowSidebar('left-0')}/>

            <div
              className={`absolute top-2${isMobileViewSelected ? ' xl:hidden' : ''} ${
                showSidebar === 'left-0' ? 'left-64' : '-left-64'
              } z-50 transition-all duration-300`}
            >
              <CustomIcon icon="close" className="text-white cursor-pointer p-3" size="2xl"
                          onClick={() => setShowSidebar('-left-64')}/>
            </div>
          </div>

          <div className="flex justify-between items-center w-full">
            <h4 className="uppercase text-white text-sm tracking-wider mt-1">
              {location === '/'
                ? 'DASHBOARD' : location.startsWith("/blogs/")
                  ? <div>
                    <Link to={{pathname: `/blogs`}} className='link'>Blogs</Link> > {location.replace('/blogs/', '')}
                  </div>
                  : location.toUpperCase().replace('/', '')}
            </h4>

            <div className="flex">
              <div className="ml-6 mt-2">
                <DropdownMenu
                  trigger={({triggerRef, isSelected, testId, ...props}) => (
                    <CustomIconRef ref={triggerRef} size="2xl" className="p-3 text-white cursor-pointer" {...props}
                                   icon="more_vert"/>
                  )}
                >
                  <DropdownItemGroup>
                    <DropdownItem onClick={logout}>Logout</DropdownItem>
                  </DropdownItemGroup>
                </DropdownMenu>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div className={`bg-rand-100 px-3 h-28${isMobileViewSelected ? ' xl:px-8' : ''}`}/>
    </>
  );


}
